import { defineComponent as _defineComponent } from 'vue'
import { queries } from "@/apollo";
import { LoginHistoryLog } from "@/CodegenTypes";
import { customMoment } from "@/main";
import { useTranslation } from "@/store/translation";
import { useQuery } from "@vue/apollo-composable";
import { computed, reactive, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginHistory',
  setup(__props) {

const selectedDate = ref(customMoment().format("YYYY-MM-DD"));

const { result, loading } = useQuery<{ loginHistory: LoginHistoryLog[] }>(
  queries.loginHistory,
  {
    date: selectedDate,
  },
  {
    fetchPolicy: "network-only",
  }
);

const { $t } = useTranslation();


const filters = reactive({ userId: "" });

const dateOptions = computed(() => {

  const prevDaysCount = 7;
  const options = [];
  for (let i = 0; i <= prevDaysCount; i++) {
    const mt = customMoment().subtract(i, "days");
    const label = mt.format("DD MMM YYYY (ddd)");
    const value = mt.format("YYYY-MM-DD");
    options.push({ label, value });
  }
  return options;
})


const filteredLoginHistory = computed(() => {

  return result.value?.loginHistory.filter((log) => {
    return log.userId.includes(filters.userId.toLowerCase());
  });
})


function formatDatetime(dateStr: string) {
  return customMoment(dateStr).format("ddd, DD MMM yyyy hh:mm:ss A");
}

return { __sfc: true,selectedDate, result, loading, $t, filters, dateOptions, filteredLoginHistory, formatDatetime }
}

})